import { Component, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-all-paiement-marketplace',
  standalone: false,
  templateUrl: './all-paiement-marketplace.component.html',
  styleUrl: './all-paiement-marketplace.component.scss'
})


export class AllPaiementMarketplaceComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string = "";
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  isDisabled: boolean = false;
  
  // Ajout du filtre par statut
  selectedStatus: string = '';
  statusOptions: any[] = [
    { label: 'Tous les statuts', value: '' },
    { label: 'Complété', value: 'completed' },
    { label: 'Échoué', value: 'failed' },
    { label: 'En cours', value: 'processing' },
    { label: 'En attente', value: 'pending' }
  ];
  
  // Propriétés pour le détail
  selectedItem: any = null;
  showDetailModal: boolean = false;
  
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  @ViewChild('detailModal') detailModal!: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService
  ) {
    this.user_reference = this.localstorage.getUsers().data.reference;
    console.log("this.user_reference", this.user_reference);
    this.FecthDataService.actionCreated$.subscribe(() => {
      this.getAllListePaiementMarketPlace();
    });
  }

  ngOnInit() {
    this.getAllListePaiementMarketPlace();
  }

  // Méthode pour ouvrir le modal de détails
  openDetailModal(item: any) {
    this.selectedItem = item;
    this.modalService.open(this.detailModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true
    });
  }

  // Méthode pour obtenir le badge de statut
  getStatusBadge(statut: string): string {
    const statusMap: {[key: string]: string} = {
      'completed': 'bg-success',
      'failed': 'bg-danger',
      'pending': 'bg-warning',
      'processing': 'bg-info',
      'cancelled': 'bg-secondary'
    };
    return statusMap[statut] || 'bg-secondary';
  }

  // Méthode pour obtenir le libellé du statut en français
  getStatusLabel(statut: string): string {
    const statusMap: {[key: string]: string} = {
      'completed': 'Complété',
      'failed': 'Échoué',
      'pending': 'En attente',
      'processing': 'En cours',
      'cancelled': 'Annulé'
    };
    return statusMap[statut] || statut;
  }

  // Méthode pour formater la date
  formatDate(date: string): string {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getAllListePaiementMarketPlace() {
    this.isLoading = true;
    this.authService.getAllListePaiementMarketPlace(this.user_reference).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length;
        this.applyFilters(); // Appliquer les filtres après chargement
        console.log("la reponse du webservice", this.items);
      },
      (error) => {
        console.log("une erreur est survenue", error);
        this.isLoading = false;
      }
    )
  }

  // Ajoutez cette méthode dans votre composant
resetFilters() {
  this.searchTerm = '';
  this.selectedStatus = '';
  this.applyFilters();
}

  // Méthode pour appliquer tous les filtres
 applyFilters() {
  let filtered = this.items;

  // Filtre par statut
  if (this.selectedStatus) {
    filtered = filtered.filter(item => item.statut === this.selectedStatus);
  }

  // Filtre par date
  if (this.dateDebut) {
    const startDate = new Date(this.dateDebut);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(item => {
      const itemDate = new Date(item.created_at);
      return itemDate >= startDate;
    });
  }

  if (this.dateFin) {
    const endDate = new Date(this.dateFin);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(item => {
      const itemDate = new Date(item.created_at);
      return itemDate <= endDate;
    });
  }

  // Filtre par recherche
  if (this.searchTerm && this.searchTerm.trim() !== '') {
    const search = this.searchTerm.toLowerCase().trim();
    filtered = filtered.filter(item =>
      (item?.reference && item.reference.toLowerCase().includes(search)) ||
      (item?.vendeur?.nom && item.vendeur.nom.toLowerCase().includes(search)) ||
      (item?.vendeur?.prenom && item.vendeur.prenom.toLowerCase().includes(search)) ||
      (item?.vendeur?.telephone && item.vendeur.telephone.toLowerCase().includes(search)) ||
      (item?.phone_number && item.phone_number.toLowerCase().includes(search)) ||
      (item?.statut && item.statut.toLowerCase().includes(search)) ||
      (item?.montant && item.montant.toString().includes(search))
    );
  }

  this.filteredtems = filtered;
  this.totalRecords = this.filteredtems.length;
  this.first = 0;
  this.updatePaginated();
}

  // Méthode appelée lors du changement de filtre
  onStatusChange() {
    this.applyFilters();
  }

  // Méthode appelée lors de la recherche
  filterBySearchTerm() {
    this.applyFilters();
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }

  getTotalItemsMontant(items: any[]): number {
    if (!items || items.length === 0) return 0;
    return items.reduce((total, item) => total + item.montant, 0);
  }

  // Méthode pour compter les transactions par statut
  getStatusCount(status: string): number {
    if (!this.items) return 0;
    if (!status) return this.items.length;
    return this.items.filter(item => item.statut === status).length;
  }
}